import { NotificationPart } from "../../shared/notification-message";
import { CommentsFocusField, DeclarationFocusField } from "../../shared/types";
import { UseMsoAnnualActivityRefData } from "./use-mso-annual-activity-ref-data";

export type DataFocusField = {
  _id: symbol;
  field: string;
  kind: 'data';
}

type DeleteProductFocusField = {
  kind: 'msoStockholdingStorages' | 'annualActivities' | 'importerImports' | 'storageSites' | 'enforceableArrangements' | 'australianControllingCorporations';
  field: 'delete';
  productId: number;
}

export type FocusField = DataFocusField | CommentsFocusField | 
DeclarationFocusField | DeleteProductFocusField;

export function isDataFocusField(maybe?: unknown): maybe is DataFocusField {
  const maybeAs = maybe as DataFocusField;
  return (
    maybeAs != null &&
    maybeAs._id != null &&
    maybeAs.field != null &&
    maybeAs.kind === 'data'
  );
}

export function isDeleteProductFocusField(maybe?: unknown): maybe is DeleteProductFocusField {
  const maybeAs = maybe as DeleteProductFocusField;

  return (
    maybeAs != null &&
    maybeAs.field === 'delete' &&
    (maybeAs.kind === 'msoStockholdingStorages' || maybeAs.kind === 'annualActivities' 
      || maybeAs.kind === 'importerImports' || maybeAs.kind ==='enforceableArrangements' ||  maybeAs.kind === 'australianControllingCorporations' ) &&
    maybeAs.productId != null
  );
}


export type FieldMessage = {
  inline: string | undefined;
  notification: {
    parts: Array<NotificationPart> | undefined;
  }
}

export type FieldValidation<TValidationResult> = FieldMessage & {
  validationResult: TValidationResult;
}

export type FieldAlert<TValidationAlert> = FieldMessage & {
  validationAlert: TValidationAlert;
}

export type MsoProductView = UseMsoAnnualActivityRefData['products'][number];
export type MsoStockholdingStorage = {
  id?: number;
  dataSubmissionId: number;
  msoProductId?: number;
 
  storageName?: string;
  terminalName?: string;
  terminalLocation?: string;
  terminalOwners?: string | null;
 
  capacityReservedForCompany?: number;
  capacityReservedForYou?: number;
 
  physicalStorageCapacity?: number;
 
  receiveProducts?: string;
  distributeProducts?: string;
 
  expiryDate?: Date | null;
 
  terminalCoOwned?: boolean;
  terminalOperator?: string | null;
  nameOfOtherCompany?: string | null;
  storagePrice?: number | null;
  typeOfArrangementTxt?: string | null;
  typeOfArrangementEntitledCapacityTxt?: string | null;
  storageMsoFuelCategory?: number | null;
  storagePriceOffered?: number | null;
  storagePriceThatWouldBeOffered?: number | null;
 
  /** Used for React row focus matching — reference equality via Symbol. */
  _id: symbol;
  /** Used as React key — stable string, safe for JSX key={} prop. */
  _key: string;
  recordAction?: number;
};
 
export type EnforceableArrangement = {
  rowFocusField?: any;
  id?: number;
  dataSubmissionId: number;
  msoProductId?: number;
 
  ownerName?: string;
  beneficiary?: string;
 
  stockOwnershipAgreementType?: number;
  volume?: number;
 
  obligationDate?: string | null;
  startDateOfThisArrangement?: string | null;
  endDateOfThisArrangement?: string | null;
 
  /** Used for React row focus matching — reference equality via Symbol. */
  _id: symbol;
  /** Used as React key — stable string, safe for JSX key={} prop. */
  _key: string;
  recordAction?: number;
};
 
export type AustralianControllingCorporation = {
  id?: number;
  dataSubmissionId: number;
 
  australianControllingCorporationName?: string;
  newCorporationName?: string;
  abn?: string;
  acn?: string;
  address?: string;
  contactInformation?: string;
  comments?: string;
  hasChangedInPreviousYear?: boolean;
 
  /** Used for React row focus matching — reference equality via Symbol. */
  _id: symbol;
  /** Used as React key — stable string, safe for JSX key={} prop. */
  _key: string;
  recordAction?: number;
};